import React, { useState, useEffect } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";

export const FinancialsData = (props) => {
  const [rowDataParams, setRowDataParams] = useState(null);
  const rowHeight = 24;
  const maxHeight = window.innerHeight - 265;

  useEffect(() => {
    setRowDataParams(props.data);
  }, []);

  const getCellStyle = (params) => {
    var style = {};
    style["cursor"] = "default";
    return style;
  };
  return (
    <div style={{ padding: "25px 25px 40px 25px", backgroundColor: "white" }}>
      <div style={{ marginBottom: 15 }}>
        The Internal Rate of Return (IRR) for the plant is{" "}
        {props.irr !== null ? (props.irr * 100).toFixed(2) : "NA"}%, while the
        Levelized Cost of Energy (LCOE) is estimated to be{" "}
        {props.lcoe !== null ? props.lcoe.toFixed(2) : "NA"}€/kWh.
      </div>
      <div
        style={{
          width: "100%",
          margin: "0px auto -20px auto",
          height: maxHeight,
        }}
        className="ag-theme-balham"
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            sortable: true,
            resizable: true,
            minWidth: 180,
            maxWidth: 600,
            flex: 1,
            filterParams: { buttons: ["reset"] },
            cellStyle: getCellStyle,
          }}
          getContextMenuItems={(params) => [
            "copy",
            "copyWithHeaders",
            "paste",
            "separator",
            {
              name: "Export",
              icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
              subMenu: [
                "csvExport",
                {
                  name: "Excel Export (.xlsx)",
                  icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                  action: () => {
                    params.api.exportDataAsExcel({ sheetName: "Export" });
                  },
                },
              ],
            },
          ]}
          rowData={rowDataParams}
          getRowHeight={(params) => {
            return rowHeight;
          }}
          popupParent={document.body}
          suppressDragLeaveHidesColumns={true}
          stopEditingWhenGridLosesFocus={true}
          singleClickEdit={true}
        >
          <AgGridColumn field="Year" headerName="Year" minWidth={60} />
          <AgGridColumn
            field="NPV"
            headerName="NPV (€)"
            minWidth={120}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
          />
          <AgGridColumn
            field="Total Cash Flow Discounted"
            headerName="Total Cash Flow Discounted (€/y)"
            minWidth={230}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
          />
          <AgGridColumn
            field="Net Cash Flow"
            headerName="Net Cash Flow (€/y)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
          />
          <AgGridColumn
            field="Positive Cash Flow"
            headerName="Positive Cash Flow (€/y)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
          />
          <AgGridColumn
            field="Negative Cash Flow"
            headerName="Negative Cash Flow (€/y)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
          />
          <AgGridColumn
            field="Annual production"
            headerName="Annual production (MWh/y)"
            minWidth={200}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field="Sold electricity"
            headerName="Price sold electricity (€/kWh)"
            minWidth={200}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field="Annual injection"
            headerName="Annual injection (MWh/y)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field="Grid injection"
            headerName="Grid injection (€/y)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field="Tax reduction"
            headerName="Tax reduction (€/y)"
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field={`${props.type} Positive Cash Flow`}
            headerName={`${props.type} Positive Cash Flow (€/y)`}
            minWidth={200}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field={`${props.type} Negative Cash Flow`}
            headerName={`${props.type} Negative Cash Flow (€/y)`}
            minWidth={200}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field="Battery Positive Cash Flow"
            headerName="Battery Positive Cash Flow (€/y)"
            minWidth={220}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
          <AgGridColumn
            field="Battery Negative Cash Flow"
            headerName="Battery Negative Cash Flow (€/y)"
            minWidth={220}
            filter={"agNumberColumnFilter"}
            type={"numericColumn"}
            valueGetter={(params) => {
              return params.data[params.colDef.field].toFixed(2);
            }}
            hide={props.type === "PV + WT" ? true : false}
            suppressColumnsToolPanel={props.type === "PV + WT" ? true : false}
          />
        </AgGridReact>
      </div>
    </div>
  );
};

export default FinancialsData;
